<script>
import AnnouncementsApi from "@/services/announcements-api";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import carousel from 'vue-owl-carousel'

export default {

    props: {
      
      propDisplayTitle: {
          type:Boolean,
          default:true
        },

      propWhiteBackground: {
          type:Boolean,
          default:true
        },

      propFullwidth: {
          type:Boolean,
          default:false
        },

    },

    components: {
      carousel
    },
    data () {
        return {
          highlightsList:[],

        }

    },
    mounted () {
      this.getHighlights();
  },

methods: {

  getHighlights() {
        AnnouncementsApi.getHighlights(1, 100)
            .then(result => {
              if(result){
                this.highlightsList=result.list;
              }
            })
      },

},

  watch: {
   

    },
  };


</script>

<style>

/* #high-car img {
  width: 100%;
  height: 300px;
  object-fit: cover;
} */

</style>

<template>


<div class="row p-2 p-sm-4 p-lg-0 pt-lg-4 pb-lg-4" v-if="highlightsList.length > 0" :class="propWhiteBackground ? 'bg-light' : ''" style="border-radius:8px;">
      <div class="col-12">

        <div class="row pt-4 pb-4" :class="propFullwidth ? '' : 'home-page-80-width'">
            <div class="col-12 text-left">
              <h2 class="text-dark font-weight-bold">
                <div class="row ">

                  <div class="col-1">
                    <a href="javascript:void(0);" @click="$refs.hightlightprev.click();" class="mr-2">
                            <i class="fas fa-angle-left text-dark font-size-20" ></i>
                        </a>
                  </div>

                    <div class="col-10 text-center text-primary">

                      <span class="d-none d-sm-inline">Evènements & Actualités</span>
                      <span class="d-sm-none">Nouveautés</span>
                    </div>

                    <div class="col-1 text-right">

                        

                        <a href="javascript:void(0);" @click="$refs.hightlightnext.click();">
                            <i class="fas fa-angle-right text-dark font-size-20" ></i>
                        </a>
                    </div>

                </div>
              </h2>
              <h5 class="text-center font-weight-bold text-success">Evènements et actualités </h5>
            </div>
        </div>

          <div class="row mb-2 pb-4 home-page-80-width" :class="propFullwidth ? '' : 'home-page-80-width'">
            <div class="col-12">
              <carousel id="high-car" v-if="highlightsList.length > 0" :smartSpeed="2000" :autoplay="false" :autoplayHoverPause="true" :nav="false"  :dots="false"  :loop="true" 
                :items="2"  :responsive="{0:{items:1}, 576:{items:2}, 768:{items:2}, 992: {items:2}, 1200: {items:2}, 1400: {items:2}}"
                 :margin="25">

                  <template slot="prev"><span hidden ref="hightlightprev" class="prev">prev</span></template>
                  <template slot="next"><span hidden  ref="hightlightnext" class="next">next</span></template>

                  <div  class="row" v-for="(announcement) in this.highlightsList" :key="announcement.id"> 
                        <div class="col-12 p-sm-2 p-0">

                                <!-- box-shadow: rgb(0 0 0 / 57%) 0px 2px 6px 0px; -->
                                <img :src="'/api/image/get/' + announcement.image"   style="border: 1px solid #ecedf0; border-radius:7px;" >
                            </div>
                            
                        <!-- <div v-if="propDisplayTitle" class="col-12">
                          <h5 class="text-danger mb-0 pb-0 text-left text-uppercase font-weight-bold">{{announcement.title}} </h5>
                          <span class="text-dark font-size-14">Promotion du <strong>{{announcement.date}}</strong> au <strong>{{announcement.date}}</strong></span>
                        </div> -->
                  </div>
             </carousel>
            </div>
          </div>
      </div>
    </div>



    





</template>                 
               